import { Typography, useMediaQuery } from "@mui/material";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiStack } from "../../../components";
import { AccountPostingMobile } from "./accountPostingMobile";
export var AccountPosting = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'AccountPosting' : _a;
    var currValue = value[name];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var accountPostingColumn = [{
            field: 'Account',
            headerName: 'Account',
            minWidth: 180,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row, _params$row2;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        color: 'text.primary',
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Account), /*#__PURE__*/ React.createElement(Typography, {
                        color: 'text.secondary',
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.code));
                }
            }
        }, {
            field: 'DebitAmount',
            headerName: 'Debit Amount (₹)',
            minWidth: 200,
            headerAlign: 'right',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'CreditAmount',
            headerName: 'Credit Amount (₹)',
            minWidth: 200,
            headerAlign: 'right',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'Remark',
            headerName: 'Remark',
            headerAlign: 'left',
            disableColumnMenu: true,
            minWidth: 420,
            editable: true
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(AccountPostingMobile, null) : /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Posting Details",
        isCollapsible: true,
        columns: accountPostingColumn,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                aggregation: {
                    model: {
                        DebitAmount: 'sum',
                        CreditAmount: 'sum'
                    }
                }
            }
        },
        disableAddRow: true,
        disableDeleteRow: true,
        rows: currValue || [{
                id: '01',
                Account: '*Purchase*',
                code: '*BM9090*',
                DebitAmount: '*00.00*',
                CreditAmount: '*00.00*'
            }, {
                id: '02',
                Account: '*Purchase*',
                code: '*BM9090*',
                DebitAmount: '*00.00*',
                CreditAmount: '*00.00*'
            }],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
